export const INTERVENTION_MOBILE_PHONE = {
  type: 'cellphone',
  title: 'Cadastre seu celular',
  description:
    'Um celular cadastrado ajuda você a recuperar o acesso a sua conta, caso você esqueça sua senha ou e-mail.',
  redirectModal: '#/mobilephone',
  dialogTitle: 'Cadastre seu celular e aumente a segurança da sua conta',
  dialogDescription:
    'Seu celular cadastrado ajuda a recuperar o acesso à sua conta, caso você esqueça sua senha ou e-mail ',
};

export const INTERVENTION_CPF = {
  type: 'docNumber',
  title: 'Cadastre seu CPF',
  description:
    'Seu CPF nos ajuda a saber quem é você. Complete seu cadastro e colabore conosco para tornar sua experiência na Globo cada vez melhor.',
  redirectModal: '#/mobilephone',
  dialogTitle:
    'Complete seu cadastro e aproveite uma experiência ainda mais personalizada',
  dialogDescription: 'Seus dados serão usados somente de acordo com a nossa ',
};

export const INTEVENTION_BORN = {
  type: 'born',
  title: 'Atualize sua data de nascimento e complete seu cadastro conosco',
  description:
    'Complete seu cadastro e aproveite uma experiência ainda mais personalizada',
  redirectModal: '#/mobilephone',
  dialogTitle: '',
  dialogDescription: '',
};

export const INTERVENTION_LOCALIZATION = {
  type: 'localization',
  title: 'Atualize sua localização e complete seu cadastro conosco',
  description:
    'Com a seua localização podemos lhe oferecer conteúdos independente de onde você esteja.',
  redirectModal: '#/mobilephone',
  dialogTitle: '',
  dialogDescription: '',
};

export const INTERVENTION_MULTIPLY = {
  type: 'multiply',
  title:
    'Complete seu cadastro e aproveite uma experiência ainda mais personalizada',
  description:
    'Complete seu cadastro e aproveite uma experiência ainda mais personalizada',
  redirectModal: '#/mobilephone',
  dialogTitle: '',
  dialogDescription: '',
};

export const INTERVENTION_CONFIRM_MOBILE_PHONE = {
  type: 'confirmMobilePhone',
  title: 'Confirme seu celular',
  description:
    'Seu celular confirmado ajuda a recuperar o acesso a sua conta, caso você esqueça sua senha ou e-mail.',
  redirectModal: '#/mobilephone',
  dialogTitle: 'Confirme seu celular e aumente a segurança da sua conta',
  dialogDescription:
    'Seu celular confirmado ajuda a recuperar o acesso à sua conta, caso você esqueça sua senha ou e-mail ',
};

export const INTERVENTION_CONFIRM_CPF = {
  type: 'confirmDocNumber',
  title: 'Confirme seu CPF',
  description:
    'Seu CPF nos ajuda a saber quem é você. Complete seu cadastro e colabore conosco para tornar sua experiência na Globo cada vez melhor.',
  redirectModal: '#/mobilephone',
  dialogTitle:
    'Complete seu cadastro e aproveite uma experiência ainda mais personalizada',
  dialogDescription: 'Seus dados serão usados somente de acordo com a nossa ',
};

export const INCONSISTENCY_MESSAGE = {
  type: 'inconsistency',
  title: ', identificamos uma inconsistência nos seus dados',
  description:
    'Por favor, verifique os dados informados e corrija o que for necessário.',
  dialogTitle: ', identificamos uma inconsistência nos seus dados',
  dialogDescription:
    'Por favor, verifique os dados informados e corrija o que for necessário.',
};
